import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useLocalStorageFlag from '../hooks/useLocalStorageFlag';
import { getDeferredRetryDate } from '../Utils/postProcessingJobs';

const PostProcessingJobDetails = ({ job, retryAtLabel }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useLocalStorageFlag(`postprocessing-details:${job.group_key}`);
  const blocked = job.group_jobs.find((item) => item.state === 'blocked');
  return (
    <>
      {retryAtLabel && (
        <Typography variant="caption" component="p" sx={{ color: 'text.secondary', my: 0.25 }}>
          {t('status_bar.postprocessing_retry_at', { date: retryAtLabel })}
        </Typography>
      )}
      {blocked && (
        <Typography variant="caption" component="p" sx={{ color: 'text.secondary', my: 0.25 }}>
          {t(`status_bar.postprocessing_block_${blocked.blocked_reason_key || 'processing_blocked'}`)}
        </Typography>
      )}
      {(job.job_count > 1 || blocked) && (
        <Box component="details" open={expanded} onToggle={(event) => setExpanded(event.currentTarget.open)} sx={{ fontSize: '0.72rem', mt: 0.5 }}>
          <Box component="summary" sx={{ cursor: 'pointer', py: 0.5 }}>
            {t('status_bar.postprocessing_group_details')}
          </Box>
          <Box component="ul" sx={{ pl: 2.5, my: 0.5 }}>
            {job.group_jobs.map((item, index) => (
              <li key={item.job_id ?? item.queue_entry_id ?? index}>
                {!(item.job_count > 1) && item.timeevent_id != null && (
                  <>{t('status_bar.postprocessing_job_event', { id: item.timeevent_id })}{' · '}</>
                )}
                {t('status_bar.postprocessing_group_requests', { count: Math.max(1, Number.parseInt(item.job_count, 10) || 1) })}
                {' · '}{item.state === 'blocked'
                  ? t(`status_bar.postprocessing_block_${item.blocked_reason_key || 'processing_blocked'}`)
                  : item.state === 'processing' || item.state === 'finalizing' ? t('status_bar.postprocessing_job_state_active')
                  : item.state === 'awaiting_review' ? t('status_bar.postprocessing_job_state_review')
                  : getDeferredRetryDate(item) ? t('status_bar.postprocessing_job_state_retry_scheduled')
                  : t('status_bar.postprocessing_job_state_waiting')}
              </li>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};

export default PostProcessingJobDetails;
